// DS: B16
import React from 'react';
import classnames from 'classnames';
import { PapiUser } from '@wix/da-papi-types';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import Plus from '@wix/da-ds/pkg/Icons/Plus';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Check from '@wix/da-ds/pkg/Icons/Check';
import { useWatchButton } from '../../WatchButton/useWatchButton';

import s from './UserWatchGhostButton.scss';

export interface Props {
  author: PapiUser;
  className?: string;
  watchingClassname?: string;
  iconClassName?: string;
  children?: React.ReactNode;
  disabled?: boolean;
  isWatchingBack?: boolean;
  onWatch?: () => void;
  onToggleWatchSuccess?: (isWatchingBack?: boolean) => void;
}

export const UserWatchGhostButton: React.FC<Props> = ({
  author,
  className,
  children,
  onWatch,
  iconClassName,
  isWatchingBack,
  watchingClassname,
  onToggleWatchSuccess,
}) => {
  const { onClick, text, isWatching, biData } = useWatchButton(
    author,
    author?.isWatching,
    isWatchingBack,
    false,
    onToggleWatchSuccess
  );

  return (
    <GhostButton
      size="small"
      variant="approval-green"
      className={classnames(
        s['root'],
        isWatching && s['watching'],
        isWatching && watchingClassname,
        className
      )}
      biData={biData}
      onClick={() => {
        onClick();
        if (!isWatching) {
          onWatch && onWatch();
        }
      }}
    >
      <Plus
        customSizable
        className={classnames(s['plus-icon'], iconClassName)}
        size={IconSize.SMALL}
      />
      {isWatching && (
        <Check
          customSizable
          className={classnames(s['check-icon'], iconClassName)}
          size={IconSize.SMALL}
        />
      )}
      {children || text}
    </GhostButton>
  );
};
UserWatchGhostButton.displayName = 'UserWatchGhostButton';

export default UserWatchGhostButton;
